module.exports = __webpack_public_path__ + "img/pore_survey_2.e86fcb90.png";